function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useRef } from 'react';
import styles from './GacContainer.less';
import dropdownStyles from '../realtorCategoryDropdown/dropdown.less';
import { GacInputField } from '../gacinput/GacInputField';
import { CategoryDropdown } from '../realtorCategoryDropdown/CategoryDropdown';
var GacContainer = function GacContainer(_ref) {
  var id = _ref.id,
    apiEndPoint = _ref.apiEndPoint,
    buttonText = _ref.buttonText,
    placeholder = _ref.placeholder,
    onButtonClick = _ref.onButtonClick,
    onSuggestionSelected = _ref.onSuggestionSelected,
    _ref$nextgenData = _ref.nextgenData,
    nextgenData = _ref$nextgenData === void 0 ? true : _ref$nextgenData,
    isBranchenbuchSearch = _ref.isBranchenbuchSearch,
    onCategorySelected = _ref.onCategorySelected,
    selectedCategory = _ref.selectedCategory;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expandedView = _useState2[0],
    expandSearchBlock = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    fakeInputValue = _useState4[0],
    setFakeInputValue = _useState4[1];
  var fakeInputRef = useRef(null);
  var gacInputRef = useRef(null);
  var expandedStyle = expandedView ? styles.expanded : '';
  useEffect(function () {
    var body = document.getElementsByTagName('body')[0];
    if (expandedView) {
      body.classList.add("".concat(styles.overlayOpened));
    } else {
      var _gacInputRef$current;
      body.classList.remove("".concat(styles.overlayOpened));
      setFakeInputValue(((_gacInputRef$current = gacInputRef.current) === null || _gacInputRef$current === void 0 ? void 0 : _gacInputRef$current.getValue()) || '');
      setTimeout(function () {
        var input = fakeInputRef.current;
        input.style.transform = 'none';
      }, 600);
    }
  }, [expandedView]);
  useEffect(function () {
    var _fakeInputRef$current, _fakeInputRef$current2;
    var handler = function handler(e) {
      e.preventDefault();
      var input = fakeInputRef.current;
      input.style.transform = 'translateY(-10000px)';
      expandSearchBlock(true);
      setTimeout(function () {
        var _gacInputRef$current2;
        (_gacInputRef$current2 = gacInputRef.current) === null || _gacInputRef$current2 === void 0 || _gacInputRef$current2.focus();
      }, 650);
    };
    (_fakeInputRef$current = fakeInputRef.current) === null || _fakeInputRef$current === void 0 || _fakeInputRef$current.addEventListener('touchstart', handler);
    (_fakeInputRef$current2 = fakeInputRef.current) === null || _fakeInputRef$current2 === void 0 || _fakeInputRef$current2.addEventListener('focus', handler);
    return function () {
      var _fakeInputRef$current3;
      return (_fakeInputRef$current3 = fakeInputRef.current) === null || _fakeInputRef$current3 === void 0 ? void 0 : _fakeInputRef$current3.removeEventListener('touchstart', handler);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex one-whole padding-m margin-left-none background-white ".concat(styles.searchContainer, " ").concat(expandedStyle)
  }, /*#__PURE__*/React.createElement("div", {
    className: "one-whole background-white padding-xl ".concat(styles.hiddenBlock, " ").concat(expandedStyle)
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onButtonClick,
    className: "button button-primary ".concat(styles.hiddenButton, " ").concat(expandedStyle, " ").concat(isBranchenbuchSearch ? styles.branchenbuch : ''),
    type: "submit",
    "data-testid": "makler_finden_overlay"
  }, buttonText)), /*#__PURE__*/React.createElement("button", {
    className: "button-icon-standalone padding-none ".concat(styles.closeButton, " ").concat(expandedStyle),
    onClick: function onClick() {
      return expandSearchBlock(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "is24-icon-closing font-regular"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid-item input-text-container ".concat(styles.searchBar, " ").concat(expandedStyle, " ").concat(isBranchenbuchSearch ? styles.branchenbuch : '')
  }, /*#__PURE__*/React.createElement(CategoryDropdown, {
    hidden: !isBranchenbuchSearch,
    onCategorySelected: onCategorySelected,
    selectedCategory: selectedCategory,
    displayClass: expandedView ? dropdownStyles.visible : 'desk-hide lap-hide'
  }), /*#__PURE__*/React.createElement(GacInputField, {
    id: id,
    ref: gacInputRef,
    apiEndPoint: apiEndPoint,
    onSuggestionSelected: onSuggestionSelected,
    keepFocus: true,
    placeholder: placeholder,
    nextgenData: nextgenData
  }), /*#__PURE__*/React.createElement("input", {
    ref: fakeInputRef,
    type: "text",
    className: "input-text ".concat(styles.searchInputFake),
    placeholder: placeholder,
    value: fakeInputValue,
    readOnly: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid-item palm-hide padding-left-m grid grid-flex"
  }, /*#__PURE__*/React.createElement(CategoryDropdown, {
    hidden: !isBranchenbuchSearch,
    onCategorySelected: onCategorySelected,
    selectedCategory: selectedCategory
  }), /*#__PURE__*/React.createElement("button", {
    onClick: onButtonClick,
    className: "button button-primary",
    "data-testid": "makler_finden_desk",
    type: "submit"
  }, buttonText)), /*#__PURE__*/React.createElement("div", {
    className: "grid-item desk-hide lap-hide padding-left-m"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onButtonClick,
    className: "button button-primary button-icon-standalone-medium",
    type: "submit",
    "data-testid": "makler_finden_mobile",
    "aria-label": buttonText
  }, /*#__PURE__*/React.createElement("span", {
    className: "is24-icon-search",
    "aria-hidden": "true"
  }))));
};
export default GacContainer;